import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import '../../modules/maintenance-model/maintenanceModel.scss';

export const MaintenanceModelModal = ({ maintenanceModel, toggle, isOpen }) => {
  const { name, description } = maintenanceModel;
  return (
    <>
      <Modal className="modal-maintenance-model" isOpen={isOpen} toggle={toggle} zIndex={9999}>
        <ModalHeader toggle={toggle}>{name}</ModalHeader>
        <ModalBody>
          <div className="modal-description-maintenance-model">
            <div className="modal-title-description">
              <strong>
                Descrição <br />
              </strong>
            </div>
            <div className="modal-description-maintenance-text">{description}</div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
